import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Pedido/descargarPedidosCloud`, method: 'POST', body: null, token: token})
}
